import { SVGProps, memo } from 'react';

const CheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='13'
    height='10'
    viewBox='0 0 13 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.796143 4.54926L4.17395 7.92707L11.3049 0.796143'
      stroke='black'
      strokeOpacity='0.87'
      strokeWidth='2.25187'
    />
  </svg>
);

export default memo(CheckMark);
